import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import appDevelopment from "../images/mobile-app-development.avif";
import { Helmet } from "react-helmet-async";

export default function Mobileappdevelopmentservices() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  const techStacks = [
    { icon: "fa-mobile-alt", title: "Flutter", desc: "Google's powerful UI toolkit for building natively compiled, beautiful cross-platform apps from a single Dart codebase — fast, expressive, and productive." },
    { icon: "fa-react", title: "React Native", desc: "Build truly native mobile apps using JavaScript & React — leverage your web skills for high-performance iOS & Android apps with near-native feel." },
    { icon: "fa-android", title: "Kotlin Multiplatform", desc: "Share business logic & even UI (via Compose Multiplatform) across Android, iOS, web & desktop — ideal for teams wanting native performance with maximum code reuse." },
    { icon: "fa-apple", title: "SwiftUI", desc: "Apple's modern declarative framework for crafting stunning, responsive iOS, iPadOS, macOS & watchOS apps with smooth animations and intuitive design." },
    { icon: "fa-cube", title: "Xamarin / .NET MAUI", desc: "Develop native cross-platform apps with C# & .NET — share code across iOS, Android & more while maintaining full native capabilities." },
    { icon: "fa-vr-cardboard", title: "ARCore & ARKit", desc: "Integrate immersive augmented reality experiences — place 3D objects in the real world, enable interactive features, and create engaging apps that blend digital & physical." },
  ];

  return (
    <div>
      <Helmet>
        <title>Custom Mobile App Development Services - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/mobile-app-development-services/" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Mobile App Development Services
            </h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mt-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="row align-items-center g-5">
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1200">
            <div className="section-title text-start mb-4">
              <h2>Explore Cutting-Edge Mobile Development</h2>
              <h3 style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                Next-Gen <span>Mobile App Solutions</span>
              </h3>
            </div>
            <p style={{ textAlign: "justify", lineHeight: 1.8, fontSize: "1.05rem" }}>
              In 2025+, mobile apps are the primary touchpoint for customers — more personal, faster, and more engaging than websites. We build high-performance, user-centric mobile experiences that boost retention, drive revenue, and give your business a real competitive advantage.
            </p>
            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              From startups to enterprises, our expert team delivers cross-platform & native apps with stunning UI, seamless performance, secure backend integration, and future-ready features — all under one roof.
            </p>
          </div>

          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
            <img
              src={appDevelopment}
              alt="Mobile App Development Services"
              className="img-fluid "
              style={{ borderRadius: "16px" }}
            />
          </div>
        </div>
      </div>

      {/* Tech Stack / How We Do It - Cards */}
      <div className="container my-5 py-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-2">
          <h3>Our Modern Mobile Tech Stack</h3>
        </div>
        <div className="row g-4">
          {techStacks.map((item, i) => (
            <div className="col-lg-4 col-md-6" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '16px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <i
                  className={`fa-brands ${item.icon} fa-4x mb-4`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <h5 className="mb-3 fw-bold">{item.title}</h5>
                <p className="mb-0 small" style={{ lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Why Mobile Apps? - Closing Section */}
      <div
        className="container-fluid py-2"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}08 0%, #f8f9fa 100%)`,
        }}
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h3 className="mb-4" style={{ fontWeight: 700 }}>
                Why Mobile Apps Are Essential for Businesses in 2026+
              </h3>
              <p className="lead mb-4" style={{ lineHeight: 1.8 }}>
                Mobile apps offer unmatched convenience, personalization, push notifications, offline capabilities, and loyalty-building features that websites simply can't match. They increase customer engagement, boost retention, enable new revenue streams (in-app purchases, subscriptions), and provide valuable user data insights.
              </p>
              <p style={{ fontSize: "1.1rem", maxWidth: "900px", margin: "0 auto 2rem" }}>
                We follow a user-first approach: deep market research → intuitive UX/UI → robust architecture → rigorous testing → scalable deployment. Whether native, cross-platform, or AR-enhanced — we create apps that users love and businesses profit from.
              </p>

          <a
  href="/contact"
  className="primaryBtn px-4 py-2 mb-3"
  style={{ display: "inline-block" }}
>
  Get Your Free Quote Today &rarr;
</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}